import { IAgency, IAgencyPrintout } from '../models/agency'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

type IAgencyResponse = {
  data: IAgency
  openingHours: IAgency['openingHours']
  primaryColor: string
}

export const getAgency = (id: string) => Api<IAgencyResponse>('GET', `agencies/${id}`, BaseUrl.Request)
export const getAgencyPrintout = (id: string) => Api<IApiResponse<IAgencyPrintout>>('GET', `agencies/${id}/sub-domain`, BaseUrl.Request)
